export function paginate(data, page, perPage) {
   if (!page && !perPage) {
      return data;
   }
   const startIndex = (page - 1) * perPage;
   const endIndex = page * perPage;
   return data.slice(startIndex, endIndex);
}
